<style lang="stylus">
    .wmenu-box
        position fixed
        font-size 12px
        border-radius 6px
        box-shadow 0 1px 6px rgba(0,0,0,.2)
        z-index 99
        background #fff
        padding 6px 0
        min-width 100px
        pointer-events auto
        .wmenu-item
            height 16px
            line-height 16px
            font-size 13px
            position relative
            padding 8px 30px
            cursor pointer
            user-select none
            box-sizing content-box
            display flex
            justify-content center
            align-items center
            white-space nowrap
            .varrow
                position absolute
                right 15px
                width 5px
                height 6px
            &.ban
                cursor not-allowed
                color #a0a0a0
            &:not(.ban):hover
                background #f5f7f6
            img
                margin 0 12px
            span
                pointer-events none
        .underline
            &:after
                content ''
                position absolute
                left 50%
                bottom 0
                transform translateX(-50%)
                width 83%
                height 1px
                background #0000001A
</style>

<template>
    <div class="wmenu-box" :style="{ top: fitTop + 'px', left: fitLeft + 'px' }" v-show="show" v-click-outside="clickOut">
        <div class="wmenu-item" @click="clickItem(item.id)" v-for="item in dataList" :key="item.id">
            <span>{{ $t(item.name) }}</span>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    @Component({
        components: {},
    })
    export default class Contextmenu extends Vue {
        @Prop()
        top;
        @Prop()
        left;
        @Prop()
        show;

        dataList = [
            {
                id: 0,
                name: "usertask-hidden",
            },
        ];

        get fitTop() {
            let h = this.dataList.length * 32 + 16,
                winH = window.innerHeight;
            return this.top + h + 50 > winH ? this.top - h : this.top;
        }

        get fitLeft() {
            let w = 100,
                winW = window.innerWidth;
            return this.left + w + 50 > winW ? this.left - w : this.left;
        }

        clickOut() {
            this.$emit("clickOutside");
        }

        clickItem(id) {
            this.$emit("clickItem", id);
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
    "zh": {
        "usertask-hidden": "隐藏"
    }
}
</i18n>
